const jhonData = {
  name: "Endri Isufi",
  // name2: "Richard Tea.",
  // name3: "Alexa Johnson",
  role: "Software Developer, .Net Developer, Fullstack Developer",
  ptext: "Creative Designer & Developer located in London.",
  socialLinks: [
    {
      name: "Facebook",
      url: "http://www.linkedin.com/in/endri-isufi",
      className: "social_linkedin",
    },
    {
      name: "twitter",
      url: "http://www.twitter.com/",
      className: "social_twitter",
    },
    {
      name: "googleplus",
      url: "http://www.googleplus.com",
      className: "social_googleplus",
    },
    {
      name: "pinterest",
      url: "http://www.pinterest.com",
      className: "social_pinterest",
    },
  ],
  aboutme: "About Me",
  aboutdetails:
    "An ambitious, highly motivated developer who loves creating awesome things and traveling around the world.",
  service: [

    {
      id: 1,
      iconName: "icon-recycle",
      serviceTitle: "Clean Code",
      sDetails: "Clean Code refers to the art of writing beautiful code and it’s the kind of code that is clean, maintainable, reveals the intent, reduces the guess work, and reads like a story.",
    },
    {
      id: 2,
      iconName: " icon-layers",
      serviceTitle: "Clean Architecture",
      sDetails: "Clean Architecture is a set of practices used to create modern software architecture that is simple, understandable, flexible, testable, and maintainable.",

    },
    {
      id: 3,
      iconName: "icon-strategy",
      serviceTitle: "Right Programming Language",
      sDetails: "It is very important to choose the right programming language that suits the needs and specs of your online project. There are different stats proving the popularity of various programming languages.",

    }
  ],
  contact: [
    {
      id: "1",
      title: "Contact Info",
      menuItems: [
        {
          id: 1,
          icon: "icon_pin_alt",
          text: "Address: Z105 - Tan Thinh, Thai Nguyen - Viet Nam",
        },
        {
          id: 2,
          icon: "icon_phone",
          text: "Phone: +1.900.3456.789",
        },
        {
          id: 3,
          icon: "icon_mail",
          text: "Email: yourname@somemail.com",
        },
        {
          id: 4,
          icon: "icon_globe",
          text: "Website: http://example.com",
        },
      ],
    },
  ],
  devloperBanner: [
    {
      id: 1,
      subtile: ".Net & Fullstack Developer",
      title: "Hi. \n I'm Endri",
      discription:
        "I design and code beautifully simple things,\n and I love what I do.",
    },
  ],
  devAbout: [
    {
      id: 1,
      smalltitle: "Introduce",
      aHead: "Passion \n Heart & Soul",
      aHeadTwo: " ”Any fool can write code that a computer can understand. Good programmers write code that humans can understand.” – Martin Fowler",
      adiscription:
        "An ambitious, highly motivated developer who loves creating awesome things and traveling around the world."
    },
  ],
  aboutSkill: [
    {
      id: 1,
      workName: "Web Apps",
      text: "With more than 3 years experience, I deliver powerful, yet user-intuitive content management systems for easy, scalable web apps.",
      complateProject: "",
      icon: "icon-cloud",
    },
    {
      id: 2,
      workName: "E-Commerce",
      text: "Delivering custom designs and functionalities that drive conversion, making online trading faster and smarter.",
      complateProject: "",
      icon: "icon-genius",
    },
    {
      id: 3,
      workName: "Desktop Applications",
      text: "Delivering custom designs and functionalities that drive conversion, making online trading faster and smarter.",
      complateProject: "",
      icon: " icon-desktop",
    },
  ],
  awards: [
    {
      id: 1,
      image: "b1.png",
      ctile: "70-483: Programming in C#",
      date: "April 2020",
      descriptions: [
        {
          text: "Managing program flow and events"
        },
        {
          text: "Asynchronous programming and threading"
        },
        {
          text: "Data validation and working with data collections including LINQ"
        },
        {
          text: "Handling errors and exceptions"
        },
        {
          text: "Working with arrays and collections"
        },
        {
          text: "Working with variables, operators, and expressions"
        }
        ,
        {
          text: "Working with classes and methods"
        }
        ,
        {
          text: "Decision and iteration statements"
        }
      ],
      url: "http://www.pinterest.com",
      linktext: "view More",
    },
    {
      id: 2,
      image: "b2.png",
      ctile: "70-480: Programming in HTML5 with JavaScript and CSS3",
      date: "March 2021",
      descriptions: [
        {
          text: "Managing program flow and events"
        },
        {
          text: "Asynchronous programming"
        },
        {
          text: "Managing program flow and events"
        },
        {
          text: "Data validation and working with data collections including JQuery"
        },
        {
          text: "Handling errors and exceptions"
        }
        ,
        {
          text: "Arrays and collections"
        }
        ,
        {
          text: "Working with variables, operators, and expressions"
        },
        {
          text: "Working with prototypes and methods"
        }
      ],
      url: "http://www.pinterest.com",
      linktext: "view More",
    }
  ],
  contacttitle: "Contact Form",
};

export default jhonData;
